import { useNavigator } from '@repo/toolkit/use-navigator'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { toast } from 'sonner'

import { getOlTeflPrice } from '../../../api/ols/tefl-prices/get-ol-tefl-price'
import { updateOlTeflPrice } from '../../../api/ols/tefl-prices/update-ol-tefl-price'
import { ItemNotFound } from '../../../components/elements/item-not-found'
import LoadingScreen from '../../../components/elements/loading/loading-screen'
import OlTeflPriceForm from '../../../components/pages/ols/ol-tefl-prices/ol-tefl-price-form'
import { mapOlTeflPriceToInput } from '../../../components/pages/ols/utils'
import { Paths } from '../../../lib/constants/path'
import { twoButtonsConfig } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../../lib/utils/functions/misc.functions'
import { constructOlPath } from './utils'

type Props = {
  olId: number
}

const OlTeflPriceUpdate: React.FC<Props> = ({ olId }) => {
  const { teflPriceId: id } = useParams<{ teflPriceId: string }>()
  const { back } = useNavigator()
  const queryClient = useQueryClient()

  if (!id || isNaN(+id)) return <ItemNotFound title="Identifiant de prix de Tefl invalide" />

  const { data: olTeflPrice, isPending } = useQuery({
    queryKey: ['ol-tefl-price', id],
    queryFn: () => getOlTeflPrice({ id: +id, olId })
  })

  const { mutateAsync } = useMutation({
    mutationFn: updateOlTeflPrice,
    onError: showAxiosError,
    onSuccess() {
      queryClient.invalidateQueries({ exact: true, queryKey: ['ol-tefl-price', id] })
      toast.success('Prix de Tefl modifié avec succès')
    }
  })

  if (isPending) return <LoadingScreen />
  if (!olTeflPrice) return <ItemNotFound title="Prix de Tefl non trouvé" />

  return (
    <div>
      <OlTeflPriceForm
        mode="update"
        defaultValues={mapOlTeflPriceToInput(olTeflPrice)}
        buttonsConfig={twoButtonsConfig({
          onCancel: () => back(constructOlPath(Paths.OL_DETAILS_TEFL_PRICES_PAGE, olId)),
          onConfirm: (values) => mutateAsync({ id: +id, olId, ...values })
        })}
      />
    </div>
  )
}

export default OlTeflPriceUpdate
